import PropTypes from 'prop-types';
import React from 'react';

import { motion } from 'framer-motion';
import { isNil } from 'lodash';

const IconProduct = ({ height, width }) => (
  <motion.svg
    // initial={{ rotate: '0deg' }}
    // whileHover={{
    //   rotate: '180deg',
    //   transition: { duration: 1, type: 'spring' },
    // }}
    focusable="false"
    viewBox={!isNil(height) && !isNil(width) ? `0 0 ${width} ${height}` : '0 0 46 45'}
    aria-hidden="true"
    width={width || '46'}
    height={height || '45'}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={{
      width: !isNil(width) ? `${width}px` : 'inherit',
      height: !isNil(height) ? `${height}px` : 'inherit',
    }}
  >
    <path
      d="M38.5255 28.4804V17.5949C40.2026 17.3657 41.5 15.9277 41.5 14.1891C41.5 12.2914 39.9561 10.7478 38.0585 10.7478C37.0162 10.7478 36.0827 11.2153 35.4511 11.9495L25.6767 6.16306C25.7267 5.9302 25.7542 5.68893 25.7542 5.44131C25.754 3.54391 24.2101 2 22.3125 2C20.4148 2 18.8711 3.54391 18.8711 5.44131C18.8711 5.74755 18.9152 6.04288 18.9906 6.32572L9.8828 11.7667C9.25897 11.1378 8.39501 10.7475 7.44131 10.7475C5.54391 10.7475 4 12.2914 4 14.1891C4 15.8045 5.12067 17.1601 6.62437 17.5284V28.5202C5.12067 28.8885 4 30.2438 4 31.8595C4 33.7571 5.54391 35.3008 7.44131 35.3008C8.4593 35.3008 9.37279 34.854 10.0034 34.149L18.9275 39.4802C18.8927 39.6763 18.8711 39.8769 18.8711 40.0827C18.8711 41.9803 20.4151 43.524 22.3125 43.524C24.2099 43.524 25.7538 41.9801 25.7538 40.0827C25.7538 39.9366 25.7417 39.7937 25.724 39.6527L35.2176 34.0325C35.8491 34.806 36.8092 35.301 37.8833 35.301C39.7809 35.301 41.3248 33.7571 41.3248 31.8597C41.3248 30.1818 40.1172 28.7824 38.5255 28.4804ZM35.0627 29.894L29.778 26.8205V19.2381L35.2782 16.2087C35.7501 16.8562 36.4405 17.3321 37.2415 17.5281V28.4802C36.3433 28.6506 35.5681 29.1708 35.0627 29.894ZM7.90862 28.4536V17.5949C8.83028 17.4691 9.63518 16.9781 10.1747 16.2716L15.022 19.2197V26.8157L10.0564 29.6282C9.52068 29.0011 8.7644 28.5706 7.90862 28.4536ZM16.3063 19.9208L21.7579 22.7826V29.6634L16.3063 26.8016V19.9208ZM22.3999 16.0481L27.7543 18.8585L22.3999 21.6689L17.0455 18.8585L22.3999 16.0481ZM23.0422 22.7826L28.4938 19.9208V26.8016L23.0422 29.6634V22.7826ZM38.0582 12.0318C39.2477 12.0318 40.2155 12.9996 40.2155 14.1888C40.2155 15.3781 39.2477 16.3459 38.0582 16.3459C36.8687 16.3459 35.9012 15.3781 35.9012 14.1888C35.9012 12.9996 36.869 12.0318 38.0582 12.0318ZM34.81 13.0627C34.6871 13.4162 34.6169 13.7942 34.6169 14.1891C34.6169 14.4851 34.6585 14.7706 34.7292 15.0449L29.1285 18.1295L23.0422 14.9347V8.80333C23.9245 8.61205 24.6822 8.08249 25.1704 7.3562L34.81 13.0627ZM22.3125 3.28424C23.5017 3.28424 24.4695 4.25203 24.4695 5.44131C24.4695 6.63059 23.5017 7.59837 22.3125 7.59837C21.1232 7.59837 20.1554 6.63059 20.1554 5.44131C20.1554 4.25203 21.1232 3.28424 22.3125 3.28424ZM19.5513 7.4866C20.0738 8.1904 20.8567 8.68679 21.7577 8.83377V14.9347L15.6875 18.1211L10.7513 15.1194C10.8347 14.8229 10.8826 14.5117 10.8826 14.1888C10.8826 13.7072 10.7824 13.2488 10.6027 12.8321L19.5513 7.4866ZM5.28424 14.1891C5.28424 12.9998 6.25203 12.032 7.44131 12.032C8.63059 12.032 9.59837 12.9998 9.59837 14.1891C9.59837 15.3783 8.63059 16.3461 7.44131 16.3461C6.25203 16.3461 5.28424 15.3783 5.28424 14.1891ZM7.44131 34.0166C6.25203 34.0166 5.28424 33.0488 5.28424 31.8595C5.28424 30.6702 6.25203 29.7024 7.44131 29.7024C8.63059 29.7024 9.59837 30.6702 9.59837 31.8595C9.59837 33.0488 8.63059 34.0166 7.44131 34.0166ZM10.6663 33.0492C10.8038 32.6778 10.8828 32.2782 10.8828 31.8595C10.8828 31.4685 10.8142 31.0939 10.6934 30.7434L15.6759 27.9214L21.7579 31.1139V36.6898C20.7626 36.8522 19.9112 37.4411 19.3962 38.2644L10.6663 33.0492ZM22.3125 42.2396C21.1232 42.2396 20.1554 41.2718 20.1554 40.0825C20.1554 38.8932 21.1232 37.9252 22.3125 37.9252C23.5017 37.9252 24.4695 38.893 24.4695 40.0825C24.4695 41.272 23.5017 42.2396 22.3125 42.2396ZM25.3133 38.4027C24.838 37.5569 24.0168 36.9317 23.0419 36.7202V31.1137L29.1196 27.9232L34.5361 31.0732C34.4765 31.3261 34.442 31.5885 34.442 31.8593C34.442 32.2228 34.4997 32.5731 34.6047 32.9023L25.3133 38.4027ZM37.8833 34.0166C36.694 34.0166 35.7262 33.0488 35.7262 31.8595C35.7262 30.6702 36.694 29.7024 37.8833 29.7024C39.0726 29.7024 40.0406 30.6702 40.0406 31.8595C40.0406 33.0488 39.0728 34.0166 37.8833 34.0166Z"
      fill="white"
      fillOpacity="0.8"
    />
    <path
      d="M24.9372 5.43506C24.9372 6.81577 23.8179 7.93506 22.4372 7.93506C21.0565 7.93506 19.9372 6.81577 19.9372 5.43506C19.9372 4.05435 21.0565 2.93506 22.4372 2.93506C23.8179 2.93506 24.9372 4.05435 24.9372 5.43506Z"
      fill="white"
      fillOpacity="0.8"
    />
    <path
      d="M24.9372 39.8101C24.9372 41.1908 23.8179 42.3101 22.4372 42.3101C21.0565 42.3101 19.9372 41.1908 19.9372 39.8101C19.9372 38.4293 21.0565 37.3101 22.4372 37.3101C23.8179 37.3101 24.9372 38.4293 24.9372 39.8101Z"
      fill="white"
      fillOpacity="0.8"
    />
    <path
      d="M9.93719 14.1851C9.93719 15.5658 8.81791 16.6851 7.43719 16.6851C6.05648 16.6851 4.93719 15.5658 4.93719 14.1851C4.93719 12.8043 6.05648 11.6851 7.43719 11.6851C8.81791 11.6851 9.93719 12.8043 9.93719 14.1851Z"
      fill="white"
      fillOpacity="0.8"
    />
    <path
      d="M9.93719 31.6851C9.93719 33.0658 8.81791 34.1851 7.43719 34.1851C6.05648 34.1851 4.93719 33.0658 4.93719 31.6851C4.93719 30.3043 6.05648 29.1851 7.43719 29.1851C8.81791 29.1851 9.93719 30.3043 9.93719 31.6851Z"
      fill="white"
      fillOpacity="0.8"
    />
    <path
      d="M40.5622 31.6851C40.5622 33.0658 39.4429 34.1851 38.0622 34.1851C36.6815 34.1851 35.5622 33.0658 35.5622 31.6851C35.5622 30.3043 36.6815 29.1851 38.0622 29.1851C39.4429 29.1851 40.5622 30.3043 40.5622 31.6851Z"
      fill="white"
      fillOpacity="0.8"
    />
    <path
      d="M40.5622 14.1851C40.5622 15.5658 39.4429 16.6851 38.0622 16.6851C36.6815 16.6851 35.5622 15.5658 35.5622 14.1851C35.5622 12.8043 36.6815 11.6851 38.0622 11.6851C39.4429 11.6851 40.5622 12.8043 40.5622 14.1851Z"
      fill="white"
      fillOpacity="0.8"
    />
    <g clipPath="url(#clip0_457_26522)">
      <path
        d="M22.4375 13.8726L30.3672 18.4038V27.4663L22.4375 31.9976L14.5078 27.4663V18.4038L22.4375 13.8726Z"
        fill="url(#paint0_linear_457_26522)"
      />
      <path
        d="M22.4375 13.8726L30.3672 18.4038V27.4663L22.4375 31.9976L14.5078 27.4663V18.4038L22.4375 13.8726Z"
        fill="black"
        fillOpacity="0.2"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_457_26522"
        x1="30.3672"
        y1="13.8726"
        x2="12.6132"
        y2="15.9714"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#14FF00" />
        <stop offset="1" stopColor="#CCFF00" />
      </linearGradient>
      <clipPath id="clip0_457_26522">
        <rect width="18.125" height="18.125" fill="white" transform="translate(13.375 13.8726)" />
      </clipPath>
    </defs>
  </motion.svg>
);

IconProduct.propTypes = {
  color: PropTypes.string,
  height: PropTypes.string,
  width: PropTypes.string,
};

export default IconProduct;
